<template>
  <svg id="circle" viewBox="0 0 8 8">
    <g>
      <circle r="2" cx="4" cy="4" style="stroke: none" />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconCircle extends Vue {}
</script>
